import { render, staticRenderFns } from "./CreateTrainingPage.vue?vue&type=template&id=ed9f00de&"
import script from "./CreateTrainingPage.vue?vue&type=script&lang=js&"
export * from "./CreateTrainingPage.vue?vue&type=script&lang=js&"
import style0 from "./CreateTrainingPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports